import React, { useEffect, useState } from "react";


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Pagination from '@material-ui/lab/Pagination';

import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";

import ModalUpdateDeliverymans from "components/ModalUpdateDeliverymans/ModalUpdateDeliverymans";
import ModalAddDeliverymans from "components/ModalAddDeliverymans/ModalAddDeliverymans";
import ModalDeleteDeliverymans from "components/ModalDeleteDeliverymans/ModalDeleteDeliverymans";


import "react-datepicker/dist/react-datepicker.css";
import useAuth from "hooks/useAuth";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);


export default function Deliverymans() {
    const classes = useStyles();
    const classes2 = useStyles2();
    const { storageId, storageUserType } = useAuth();
    const [modalShow, setModalShow] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [deliverymans, setDeliverymans] = useState([]);
    const [index, setIndex] = useState({ id: 1 });
    const [totalPages, setTotalPages] = useState();
    const [page, setPage] = useState(1);
    useEffect(() => {
        getAllDeliverymans();
    }, [])
    useEffect(() => {
        getAllDeliverymans();
    }, [totalPages, page])

    async function getAllDeliverymans() {
        try {
            const response = await api.get(`/deliveryman/view/${storageId}?type=${storageUserType}&page=${page}&perPage=6&search=`);
            setDeliverymans(response.data.deliverymans);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            alert('erro: ' + error)
        };
    };
    function callModal(index) {
        setIndex(index);
        setModalShowUpdate(true);
    }
    function callModalDelete(index) {
        setIndex(index);
        setModalShowDelete(true);
    }
    const handleChange = (event, value) => {
        setPage(value);
    };
    function getDeliverymanForTable() {
        let teste = [];
        for (let i = 0; i < deliverymans.length; i++) {
            teste[i] = [];
            teste[i].push(deliverymans[i].deliverymanname);
            teste[i].push(deliverymans[i].deliveryusername);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModal(deliverymans[i])}>
                            <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top-start" title="Deletar" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Close" className={classes2.tableActionButton} onClick={() => callModalDelete(deliverymans[i])}>
                            <Close className={classes2.tableActionButtonIcon + " " + classes2.close} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        };
        return teste;
    };

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para adicionar um entregador a operação</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => setModalShow(true)}>
                            Adicionar entregador
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <Card>
                <CardHeader className={classes.zindex} color={"primary"}>
                    <h4 className={classes.cardTitleWhite}>Entregadores destinados a operação</h4>
                    <p className={classes.cardCategoryWhite}></p>
                </CardHeader>
                <CardBody>
                    <Table
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={["Nome", "Usuário", "Ações"]}
                        tableData={getDeliverymanForTable()}
                    />
                </CardBody>
            </Card>
            <ModalAddDeliverymans key={String("Dlv_" + index.id)} props={index} show={modalShow}
                onHide={() => setModalShow(false)} getAllDeliverymans={getAllDeliverymans} />
            <ModalUpdateDeliverymans key={String("Upd_" + index.id)} props={index} show={modalShowUpdate}
                onHide={() => setModalShowUpdate(false)} getAllDeliverymans={getAllDeliverymans} />
            <ModalDeleteDeliverymans key={String("del_" + index.id)} props={index} show={modalShowDelete}
                onHide={() => setModalShowDelete(false)} getAllDeliverymans={getAllDeliverymans} />
            <Pagination count={totalPages} page={page} onChange={handleChange} />
        </GridContainer>
    );

}
